<div class="main" [className]="'home_Notifications'" id="notifications">
  <div class="row">





    <div id="MynotificationsAlert" class="notifications col-md-12" data-testid="div-notification-alert">

      <div class="card-aditional">
        <span class="item-action condidate-tabs" (click)="ShowNotificationDaysDropDown()"> <app-svg-icon [type]="'cap_menu'" [className]="'menu-icon'"></app-svg-icon></span>
        <div [ngClass]="[IsEnableNotificationDropdown === true ? 'daysrangedropdown-active' : 'daysrangedropdown-inactive']" class="dropdown-menu dropdown-menu-right show">
          <a href="javascript:void(0)" [ngClass]="[weeklyActive === true ? 'active-notificationdropdown' : '']" (click)="GetNotificationsByDays('weekly');" class="dropdown-item">
            {{ 'JobsAndTalent.Jobs.List.InterviewPerWeek' | translate }}
          </a>
          <a href="javascript:void(0)" [ngClass]="[monthlyActive === true ? 'active-notificationdropdown' : '']" (click)="GetNotificationsByDays('monthly');" class="dropdown-item">
            {{ 'JobsAndTalent.Jobs.List.InterviewPerMonth' | translate }}
          </a>
          <a href="javascript:void(0)" [ngClass]="[quarterlyActive === true ? 'active-notificationdropdown' : '']" (click)="GetNotificationsByDays('quarterly');" class="dropdown-item">
            {{ 'JobsAndTalent.Jobs.List.InterviewQuarter' | translate }}
          </a>
        </div>
      </div>

      <div class="notificationtabs">
        <ul class="list-unstyled" data-testid="ul-notification-container">
          <li *ngIf="permission.isCandidates==='Yes'" data-testid="li-candidates" [ngClass]="[type === 'candidate' ? 'stats-selected' : ' ']" (click)="tabSelection('candidate')">
            <app-svg-icon class="svg-icon" [type]="'user-group'" [className]="'svg-icon'"></app-svg-icon>



            <!--<span class="notification-alert" id="numcandidates">{{notification.nmStatuses}}</span>-->
            <span class="notification-alert" id="numcandidates" data-testid="span-number-of-candidates">{{candidateCount}}</span>
            {{ 'Notification.Candidates' | translate }}
          </li>
          <li *ngIf="permission.isJobs==='Yes'" data-testid="li-notification-texts" [ngClass]="[type === 'texts' ? 'stats-selected' : ' ']" (click)="tabSelection('texts')">
            <app-svg-icon class="svg-icon" [type]="'emailenvelope'" [className]="'svg-icon'"></app-svg-icon>

            <!--<span class="notification-alert" id="numtexts">{{notification.nmOfSMS}}</span>-->
            <span class="notification-alert" id="numtexts" data-testid="span-number-of-texts">{{smsCount}}</span>
            {{ 'Notification.Texts' | translate }}
          </li>
          <li *ngIf="permission.isAuthoriseJob==='Yes'||permission.isAuthoriseCandidate==='Yes'" data-testid="li-notification-authorisations" [ngClass]="[type === 'authorisations' ? 'stats-selected' : ' ']" (click)="tabSelection('authorisations')">
            <app-svg-icon class="svg-icon" [type]="'My_jobs'" [className]="'svg-icon'"></app-svg-icon>
            <!--<span class="notification-alert" id="numauthorise">{{notification.nmOfAutho}}</span>-->
            <span class="notification-alert" id="numauthorise" data-testid="span-number-of-authorisations">{{authCount}}</span>
            {{ 'Notification.Authorisations' | translate }}
          </li>
          <li *ngIf="isOBNotifitionsAllowed" data-testid="li-notification-onboarding" [ngClass]="[type === 'onBoardingNotification' ? 'stats-selected' : ' ']" (click)="tabSelection('onBoardingNotification')">
            <app-svg-icon class="svg-icon" [type]="'user-group'" [className]="'svg-icon'"></app-svg-icon>
            <span class="notification-alert" id="numauthorise" data-testid="span-number-of-onboarding">{{obTotalNotifications}}</span>
            {{ 'Notification.Onboarding' | translate }}

          </li>

          <li *ngIf="permission.isJobs==='Yes'" data-testid="li-notification-emails" [ngClass]="[type === 'email' ? 'stats-selected' : ' ']" (click)="tabSelection('email')">
            <app-svg-icon class="svg-icon" [type]="'UnReadEmail'" [className]="'svg-icon'"></app-svg-icon>

            <span class="notification-alert" id="numemails" data-testid="span-number-of-emails">{{emailCount}}</span>
            {{ 'Notification.Emails' | translate }}
          </li>

        </ul>
      </div>
      <div class="notification-alerts scrollbar" infiniteScroll
           [infiniteScrollDistance]="2"
           [infiniteScrollThrottle]="50"
           [scrollWindow]="false"
           (scrolled)="onScrollDown()">
        <ng-container *ngIf="type==='candidate'">
          <ng-container *ngIf="isNotificationLoaded && notification.candidates.length>0">
            <div *ngFor="let field of notification.candidates;" class="alerts-inner clearfix" data-testid="div-parent-for-candidates">

              <span class="notification-stack">

                <app-svg-icon class="svg-icon" [type]="'user-group'" [className]="'svg-icon'"></app-svg-icon>
              </span>
              <div class="alert-line"></div>
              <div class="alert-bubble" data-testid="div-child-for-candidates">
                <div class="alert-triangle"></div>
                <p class="alert-time"><i class="fa fa-clock-o"></i> {{field.modifiedOn}}</p>
                <p class="alert-message">{{field.firstName + ' '+ field.lastName + ' - '+ field.jobtitle + ' - ' +field.statusName }} </p>
                <span class="alert-actions" (click)="candidateDetail(field.candidateId,field.jobId)">
                  <app-svg-icon class="svg-icon" [type]="'edit'" [className]="'svg-icon'"></app-svg-icon>
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isNotificationLoaded && !notification.candidates.length">
            <h5 class="mt-5 ml-4"> {{ 'Messages.NoCandidatenotifications' | translate}}</h5>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="type==='texts'">
          <ng-container *ngIf="notification.texts.length>0">
            <div *ngFor="let field of notification.texts;" class="alerts-inner clearfix" data-testid="div-parent-for-texts">
              <span class="notification-stack">

                <app-svg-icon class="svg-icon" [type]="'emailenvelope'" [className]="'svg-icon'"></app-svg-icon>
              </span>
              <div class="alert-line"></div>
              <div class="alert-bubble" data-testid="div-child-for-texts">
                <div class="alert-triangle"></div>
                <p class="alert-time"><i class="fa fa-clock-o"></i> {{field.createdOn}}</p>
                <p class="alert-message">{{field.firstName}} {{field.lastName}} {{ 'Notification.SentAText' | translate }}</p>
                <span class="alert-actions" (click)="textDetail(field.smsInboxId)">

                  <app-svg-icon class="svg-icon" [type]="'edit'" [className]="'svg-icon'"></app-svg-icon>
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isNotificationLoaded && !notification.texts.length">
              <h5 class="mt-5 ml-4"> {{ 'Messages.Notextnotifications' | translate}}</h5>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="type==='email'">
          <ng-container *ngIf="notification.emails.length>0">
            <div *ngFor="let field of notification.emails;" class="alerts-inner clearfix" data-testid="div-parent-for-emails">
              <span class="notification-stack">

                <app-svg-icon class="svg-icon" [type]="'UnReadEmail'" [className]="'svg-icon'"></app-svg-icon>
              </span>
              <div class="alert-line"></div>
              <div class="alert-bubble" data-testid="div-child-for-texts">
                <div class="alert-triangle"></div>
                <p class="alert-time"><i class="fa fa-clock-o"></i> {{field.createdOn}}</p>
                <p class="alert-message">{{field.firstName}} {{field.lastName}} {{ 'Notification.SentAEmail' | translate }}</p>
                <span class="alert-actions" (click)="emailDetail(field.emailInboxId)">

                  <app-svg-icon class="svg-icon" [type]="'edit'" [className]="'svg-icon'"></app-svg-icon>
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!notification.emails.length">
            <h5 class="mt-5 ml-4"> {{ 'Messages.Noemailnotifications' | translate}}</h5>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="permission.isAuthoriseCandidate==='Yes'&& type==='authorisations'">
          <ng-container *ngIf="notification.authorizeCandidates.length>0">
            <div *ngFor="let field of notification.authorizeCandidates;" class="alerts-inner clearfix" data-testid="div-parent-for-authorize-candidate">
              <span class="notification-stack">
                <app-svg-icon class="svg-icon" [type]="'My_jobs'" [className]="'svg-icon'"></app-svg-icon>
              </span>
              <div class="alert-line"></div>
              <div class="alert-bubble" data-testid="div-child-for-authorize-candidate">
                <div class="alert-triangle"></div>
                <p class="alert-time"><i class="fa fa-clock-o"></i> {{field.createDateTime}}</p>
                <p class="alert-message">{{field.firstnamE2}} {{field.lastNameE2}} {{ 'Notification.Awaiting' | translate }}</p>
                <span class="alert-actions" (click)="authDetail(field.userId,field.jobId)">
                  <app-svg-icon class="svg-icon" [type]="'edit'" [className]="'svg-icon'"></app-svg-icon>
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isNotificationLoaded && !notification.authorizeCandidates.length">
              <h5 class="mt-5 ml-4"> {{ 'Messages.Youhavenovacanciesforapproval' | translate}}</h5>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="type==='authorisations'  && permission.isAuthoriseJob==='Yes'">
          <ng-container *ngIf="notification.authorisations.length>0">
            <div *ngFor="let field of notification.authorisations;" class="alerts-inner clearfix" data-testid="div-parent-for-authorisations">
              <span class="notification-stack">
                <app-svg-icon class="svg-icon" [type]="'My_jobs'" [className]="'svg-icon'"></app-svg-icon>
              </span>
              <div class="alert-line"></div>
              <div class="alert-bubble" data-testid="div-child-for-authorisations">
                <div class="alert-triangle"></div>
                <p class="alert-time"><i class="fa fa-clock-o"></i> {{field.modifiedOn}}</p>
                <p class="alert-message">{{field.jobReference}} / {{field.jobTitle}}</p>
                <span class="alert-actions" (click)="authDetail(field.userId,field.jobId)">
                  <app-svg-icon class="svg-icon" [type]="'edit'" [className]="'svg-icon'"></app-svg-icon>
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isNotificationLoaded && !notification.authorisations.length">
              <h5 class="mt-5 ml-4"> {{ 'Messages.Youhavenovacanciesforapproval' | translate}}</h5>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="type==='onBoardingNotification'">
          <ng-container *ngIf="obNotification.length>0">
            <div *ngFor="let field of obNotification;" class="alerts-inner clearfix" data-testid="div-parent-for-onboarding">

              <span class="notification-stack">

                <app-svg-icon class="svg-icon" [type]="'user-group'" [className]="'svg-icon'"></app-svg-icon>
              </span>
              <div class="alert-line"></div>
              <div class="alert-bubble" data-testid="div-child-for-onboarding">
                <div class="alert-triangle"></div>
                <p class="alert-time"><i class="fa fa-clock-o"></i> {{field.createdOn | date : 'dd/MM/yyyy hh:mm a'}}</p>
                <p class="alert-message">{{field.firstName}} {{field.lastName}} - {{field.jobTitle}} - {{field.comments}}</p>
                <span class="alert-actions" (click)="NotificationDetail(field.id,field.candidateId,field.jobId,true)">
                  <app-svg-icon class="svg-icon" [type]="'edit'" [className]="'svg-icon'"></app-svg-icon>
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="obNotification.length===0">
            <h5 class="mt-5 ml-4"> {{ 'Messages.NoCandidatenotifications' | translate}}</h5>
          </ng-container>
        </ng-container>
       

      </div>
    </div>

  </div>
</div>

